import { Outlet } from 'react-router-dom';
import { Footer } from '@/components/site/Footer';
import { Header } from '@/components/site/Header';
import { Head } from '@/components/seo/Head';
import { Alert } from '@/components/ui';
import { useSiteSettings } from '@/context/SiteContext';
import { useScrollRestoration } from '@/hooks';

/** Public site chrome: header, main landmark, footer, and metadata synchronisation. */
export function SiteLayout() {
  const settings = useSiteSettings();
  useScrollRestoration();

  return (
    <div className="flex min-h-screen flex-col">
      <Head />
      <Header />

      {settings.maintenance_mode && settings.maintenance_message && (
        <div className="shell pt-6">
          <Alert tone="warning" title="Scheduled maintenance">
            {settings.maintenance_message}
          </Alert>
        </div>
      )}

      <main id="main" className="flex-1 focus-visible:outline-none" tabIndex={-1}>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
